import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import styles from "./TabsNavigation.module.css";

const TabsNavigation = ({ onTabSelect, selectedTab }) => {
	const [isInitialRender, setIsInitialRender] = useState(true);

	const { t } = useTranslation();

	const pages = [t("menu.play"), t("menu.ranking"), t("menu.prizes"), t("menu.betwayAccount"), t("menu.rules"), t("menu.terms")];

	useEffect(() => {
		const tabElement = document.getElementById(selectedTab);
		if (tabElement) {
			// Use instant behavior for initial render, smooth for subsequent changes
			const behavior = isInitialRender ? "instant" : "smooth";
			tabElement.scrollIntoView({ behavior, block: "nearest", inline: "center" });

			if (isInitialRender) {
				setIsInitialRender(false);
			}
		}
	}, [selectedTab, isInitialRender]);

	const handleTabSelect = (tab) => {
		onTabSelect(tab);
		// The scrolling will be handled by the useEffect above
	};

	return (
		<div className={styles.container}>
			{pages.map((page, index) => (
				<div
					key={index}
					id={index}
					className={[styles.tab, selectedTab === index ? styles.tabSelected : ""].join(" ")}
					onClick={() => handleTabSelect(index)}
				>
					{page}
				</div>
			))}
		</div>
	);
};

export default TabsNavigation;
